import type { Messages } from "./en";

export const ru: Messages = {
  "app.name": "Vault Chat",
  "app.skipToContent": "Перейти к содержимому",

  "nav.label": "Главное меню",
  "nav.open": "Открыть меню",
  "nav.close": "Закрыть меню",
  "nav.chats": "Чаты",
  "nav.notes": "Блокнот",
  "nav.registers": "Данные",
  "nav.saved": "Избранное",
  "nav.settings": "Настройки",

  "chats.title": "Чаты",
  "chats.empty": "Чатов пока нет. Начните новый, чтобы поговорить с ассистентом.",
  "chats.new": "Новый чат",
  "chats.search": "Поиск по чатам",
  "chats.searchEmpty": "Ничего не найдено.",
  "chats.pinned": "Закреплённые",
  "chats.recent": "Недавние",
  "chats.archive": "Архив",
  "chats.archive.open": "Открыть архив",
  "chats.archive.close": "Назад к чатам",
  "chats.archive.empty": "Архив пуст.",
  "chats.more": "Показать ещё",
  "chats.loading": "Загружаем чаты…",
  "chats.loadFailed": "Не удалось загрузить чаты.",
  "chats.untitled": "Чат без названия",
  "chats.unreadableTitle": "Название не удаётся показать",
  "chats.running": "Пишет ответ",
  "chats.actions": "Действия с чатом «{title}»",
  "chats.handle": "Переместить «{title}»",
  "chats.action.rename": "Переименовать",
  "chats.action.pin": "Закрепить",
  "chats.action.unpin": "Открепить",
  "chats.action.moveUp": "Выше",
  "chats.action.moveDown": "Ниже",
  "chats.action.archive": "В архив",
  "chats.action.unarchive": "Вернуть из архива",
  "chats.rename.title": "Переименовать чат",
  "chats.rename.label": "Название",
  "chats.delete.title": "Удалить этот чат?",
  "chats.delete.text":
    "Чат и все его сообщения будут удалены с этого сервера. Это нельзя отменить. Резервные копии оператора могут ещё какое-то время хранить зашифрованную копию, а провайдер уже видел то, на что отвечал.",
  "chat.notFound": "Этого чата нет или он удалён.",
  "chat.newIntro": "Напишите первое сообщение, чтобы начать чат.",
  "chat.messages": "Сообщения",
  "chat.composer.label": "Сообщение",
  "chat.composer.placeholder": "Напишите сообщение",
  "chat.send": "Отправить",
  "files.attach": "Прикрепить файлы",
  "files.attached": "Прикреплённые файлы",
  "files.keep": "Сохранить в этом чате",
  "files.notKept":
    "Удаляется после ответа, а без ответа примерно через час; зашифрованная копия может оставаться в хранилище ещё день-два. Описание, написанное агентом, остаётся. Провайдер ИИ может хранить свою копию.",
  "files.kept": "сохранится",
  "files.settings": "Настройки файла",
  "files.remove": "Убрать",
  "files.preparing": "Готовится…",
  "files.refused.unsupported": "{name}: агенты не читают файлы такого типа.",
  "files.refused.tooLarge": "{name} слишком большой: файл — не больше 50 МБ, текстовый — не больше 200 КБ.",
  "files.refused.pixels": "В {name} слишком много пикселей: в картинке — не больше 50 мегапикселей.",
  "files.refused.pages": "В {name} слишком много страниц: в PDF — не больше 100.",
  "files.refused.notText": "{name} — не текстовый файл.",
  "files.refused.unreadable": "Не удалось прочитать {name}.",
  "files.refused.count":
    "{count, plural, one {К сообщению можно прикрепить не больше # файла.} few {К сообщению можно прикрепить не больше # файлов.} many {К сообщению можно прикрепить не больше # файлов.} other {К сообщению можно прикрепить не больше # файла.}}",
  "files.big.text": "Оригинал сохранит полный размер и займёт больше места. Агент читает сжатую копию.",
  "files.big.asIs": "Также отправить как есть",
  "files.open": "Открыть {name}",
  "files.saveAction": "Сохранить",
  "files.opening": "Открывается…",
  "files.saveImage": "Сохранить",
  "files.saveOriginal": "Сохранить оригинал",
  "files.error.quota": "Ваши файлы заняли всё отведённое им место.",
  "files.error.disabled": "Этот сервер не хранит файлы.",
  "files.error.tooLarge": "Файл слишком большой.",
  "files.error.limit": "Слишком много файлов ждут отправки. Сначала отправьте или уберите часть.",
  "files.error.gone": "Этот файл не сохранялся или его уже нет на сервере.",
  "notice.file.undescribed": "Модель не смогла описать файл. Она откроет его заново, когда это понадобится для ответа.",
  "chat.stop": "Остановить ответ",
  "chat.agent.none": "Добавьте провайдера в настройках, чтобы начать общение.",
  "chat.agent.starting": "Подключаемся к провайдеру…",
  "chat.agent.refused": "Сервер отклонил активного провайдера. Проверьте его в настройках.",
  "chat.agent.failed": "Не удалось подключить провайдера. Проверьте соединение.",
  "chat.settings.title": "Настройки чата",
  "chat.settings.model": "Модель",
  "chat.settings.modelDefault": "По умолчанию: {name} · {model}",
  "chat.settings.modelNone": "Нет провайдера",
  "chat.settings.effort": "Глубина рассуждений",
  "chat.settings.effortDefault": "Как задано у модели",
  "chat.settings.effort.low": "Низкая",
  "chat.settings.effort.medium": "Средняя",
  "chat.settings.effort.high": "Высокая",
  "chat.settings.effortNote":
    "Этот параметр понимают не все модели; модель, которая его не принимает, откажет в ответе.",
  "chat.settings.history": "История в каждом запросе",
  "chat.settings.historyRecent":
    "{count, plural, one {Последнее # сообщение} few {Последние # сообщения} many {Последние # сообщений} other {Последние # сообщения}}",
  "chat.settings.historyNote": "Чем больше истории, тем больше модель знает о разговоре и тем дороже каждый ответ.",
  "chat.settings.historyNone": "Без истории",
  "chat.settings.historyNoneShort": "без истории",
  "chat.settings.historyNoneNote":
    "Модель получает только отправляемое сообщение и не может прочитать прежние сообщения и файлы этого чата. Память чата передаётся всё равно. Для разовых запросов: погода, новая запись.",
  "chat.settings.messages":
    "{count, plural, one {# сообщение} few {# сообщения} many {# сообщений} other {# сообщения}}",
  "chat.settings.default": "По умолчанию: {choice}",
  "chat.settings.historyCompact": "Сводка и сообщения после неё",
  "chat.settings.compact": "Автосжатие",
  "chat.settings.compactOff": "Выключено",
  "chat.settings.compactAt": "Примерно на {count} тыс. токенов",
  "chat.settings.compactAuto": "Сводка после ~{count} тыс. токенов",
  "chat.settings.compactNote":
    "За порогом ранние сообщения перед отправкой сворачиваются в сводку, а последние уходят целиком. Сообщения не удаляются.",
  "chat.settings.compactNow": "Сжать сейчас",
  "chat.settings.memory": "Память чата",
  "chat.settings.memoryNone": "Модель ничего не сохранила для этого чата.",
  "chat.settings.memoryUnreadable":
    "Эту память не удалось прочитать, поэтому сообщения не отправятся, пока её не очистить.",
  "chat.settings.memoryNote":
    "Модель пишет эти заметки сама, без диалога, и получает их в каждом ходе этого чата. На них мог повлиять текст со страницы или из файла, поэтому очистите их, если что-то выглядит не так.",
  "chat.settings.memoryClear": "Очистить память",
  "chat.settings.memoryClearFailed": "Не удалось очистить память.",
  "chat.settings.compactShort": "Сжатие на {count} тыс.",
  "chat.settings.compactNone": "Без автосжатия",
  "chat.context.ofLimit": "История в следующем ходе: около {used} из {limit} токенов до сжатия",
  "chat.context.lastReply": "Последний ответ по счёту провайдера: {input} токенов на вход, {output} на выход",
  "chat.mention.note": "Заметка",
  "chat.mention.metric": "Ваши данные",
  "chat.mention.goes": "То, что вы упомянули, уйдёт на {host} вместе с этим сообщением.",
  "chat.mention.goesUnknown": "То, что вы упомянули, уйдёт провайдеру вместе с этим сообщением.",
  "chat.context.used": "История в следующем ходе: около {used} токенов",
  "chat.temporary.label": "Временный чат",
  "chat.temporary.note":
    "Удалится с этого сервера примерно через 30 минут после вашего ухода, кроме резервных копий. Отправленное провайдеру ИИ хранится по его правилам.",
  "chat.command.list": "Команды",
  "chat.command.compact": "Свернуть чат в сводку",
  "chat.command.new": "Начать новый чат",
  "chat.command.settings": "Открыть настройки этого чата",
  "chat.author.user": "Вы",
  "chat.author.assistant": "Ассистент",
  "chat.author.tool": "Инструмент",
  "chat.author.summary": "Сводка",
  "chat.streaming": "Пишет ответ",
  "chat.edited": "Изменено",
  "chat.deleted": "Удалено",
  "chat.cancelled": "Остановлено",
  "chat.summary.label": "Сводка сообщений выше",
  "chat.rich.note": "Примечание",
  "chat.rich.tip": "Совет",
  "chat.rich.important": "Важно",
  "chat.rich.warning": "Предупреждение",
  "chat.rich.caution": "Осторожно",
  "chat.rich.copyTable": "Скопировать таблицу в CSV",
  "chat.rich.taskDone": "Сделано",
  "chat.rich.taskOpen": "Не сделано",
  "chat.rich.tableCopied": "Таблица скопирована в CSV",
  "chat.rich.copyFailed": "Не удалось скопировать таблицу",
  "chat.rich.chart": "График",
  "chat.rich.showData": "Показать таблицей",
  "chat.rich.showChart": "Показать графиком",
  "chat.summary.writing": "Пишет сводку",
  "chat.summary.deleted": "Сводка удалена",
  "chat.message.actions": "Действия с сообщением",
  "chat.message.copy": "Скопировать текст",
  "chat.message.copied": "Текст скопирован",
  "chat.message.copyFailed": "Не удалось скопировать текст",
  "chat.message.share": "Поделиться",
  "chat.message.shareFailed": "Не удалось поделиться текстом",
  "chat.message.edit": "Изменить",
  "chat.message.save": "Сохранить в избранное",
  "chat.message.unsave": "Убрать из избранного",
  "chat.edit.title": "Изменить сообщение",
  "chat.edit.label": "Сообщение",
  "chat.edit.note": "Ответ заново не пишется; следующие сообщения увидят новый текст.",
  "chat.delete.title": "Удалить это сообщение?",
  "chat.delete.text":
    "Его текст будет удалён с этого сервера, на его месте останется отметка. Резервные копии оператора могут ещё какое-то время хранить зашифрованную копию, а провайдер его уже видел.",
  "chat.unreadable.decrypt": "Это сообщение не удаётся расшифровать.",
  "chat.unreadable.parse": "Это сообщение не удаётся прочитать.",
  "chat.unreadable.version": "Это сообщение в более новом формате. Обновите приложение, чтобы его прочитать.",
  "chat.unreadable.size": "Это сообщение слишком большое, чтобы его показать.",
  "chat.error.busy": "Дождитесь окончания ответа или остановите его.",
  "chat.error.turnLimit": "Ответы уже пишутся в трёх других чатах. Дождитесь, пока один из них закончится.",
  "chat.error.tooLarge": "Сообщение слишком длинное.",
  "chat.error.noAgent": "Провайдер не подключён. Проверьте настройки.",
  "chat.error.notFound": "Этого чата больше нет.",
  "chat.error.notRetryable": "Этот ответ уже нельзя повторить.",
  "chat.error.streaming": "Дождитесь окончания ответа.",
  "chat.error.messageGone": "Это сообщение удалено.",
  "chat.saved.mark": "В избранном",
  "chat.saved.added": "Сообщение сохранено",
  "chat.saved.removed": "Убрано из избранного",
  "turn.error.provider.blocked": "Этот сервер не разрешает адрес провайдера. Проверьте провайдера в настройках.",
  "turn.error.provider.unreachable": "Не удалось связаться с провайдером.",
  "turn.error.provider.refused": "Провайдер отклонил запрос. Проверьте API-ключ и модель в настройках.",
  "turn.error.provider.invalid": "Провайдер прислал ответ, который не удаётся прочитать.",
  "turn.error.turn.too_long": "Ответ оказался слишком длинным и был обрезан.",
  "turn.error.turn.timed_out": "Ответ писался дольше 10 минут и был остановлен.",
  "turn.error.turn.interrupted": "Ответ был прерван.",
  "turn.error.files.busy": "Сервер занят другими файлами. Попробуйте через минуту.",
  "turn.error.generic": "Не удалось получить ответ.",
  "turn.error.unknown": "Не удалось получить ответ ({code}).",
  "notes.title": "Блокнот",
  "notes.empty": "Заметок пока нет. Заметки зашифрованы, прочитать их можете только вы.",
  "notes.pick": "Откройте заметку или начните новую.",
  "notes.new": "Новая заметка",
  "notes.newTitle": "Новая заметка",
  "notes.untitled": "Без названия",
  "notes.unreadableTitle": "Заметку не прочитать",
  "notes.search": "Поиск по заметкам",
  "notes.searchEmpty": "Ничего не нашлось.",
  "notes.loading": "Загружаем заметки…",
  "notes.loadFailed": "Не удалось загрузить заметки.",
  "notes.more": "Показать ещё",
  "notes.back": "К заметкам",
  "notes.opening": "Открываем заметку…",
  "notes.openFailed": "Не удалось открыть заметку.",
  "notes.titleLabel": "Название",
  "notes.readOnly":
    "Эту заметку написала более новая версия приложения или её не прочитать, поэтому здесь её не изменить.",
  "notes.unreadableBody": "Эта версия приложения не может показать текст заметки.",
  "notes.copyTitle": "{title} (копия {time})",
  "notes.conflict": "Заметку изменили на другом устройстве. Ваша версия сохранена копией.",
  "notes.deletedElsewhere": "Заметку удалили на другом устройстве.",
  "notes.delete": "Удалить заметку",
  "notes.deleteTitle": "Удалить заметку?",
  "notes.deleteText": "Заметка удалится на всех ваших устройствах. Отменить это нельзя.",
  "notes.status.saving": "Сохраняем…",
  "notes.status.saved": "Сохранено",
  "notes.status.failed": "Не сохранено.",
  "notes.status.tooLarge": "Заметка слишком длинная, её не сохранить. Сократите её, чтобы сохранить изменения.",
  "notes.editor.area": "Текст заметки",
  "notes.editor.placeholder": "Начните писать…",
  "notes.editor.toolbar": "Форматирование",
  "notes.editor.heading": "Заголовок {level}",
  "notes.editor.bold": "Жирный",
  "notes.editor.italic": "Курсив",
  "notes.editor.strike": "Зачёркнутый",
  "notes.editor.code": "Код",
  "notes.editor.link": "Ссылка",
  "notes.editor.bulletList": "Маркированный список",
  "notes.editor.orderedList": "Нумерованный список",
  "notes.editor.taskList": "Список задач",
  "notes.editor.quote": "Цитата",
  "notes.editor.callout": "Выноска",
  "notes.editor.panel": "Сворачиваемый блок",
  "notes.editor.codeBlock": "Блок кода",
  "notes.editor.table": "Таблица",
  "notes.editor.rule": "Разделитель",
  "notes.editor.undo": "Отменить",
  "notes.editor.redo": "Повторить",
  "notes.editor.apply": "Применить",
  "notes.editor.remove": "Убрать",
  "notes.editor.linkUrl": "Адрес",
  "notes.editor.linkInvalid": "Введите адрес http, https или mailto.",
  "notes.editor.addRow": "Добавить строку",
  "notes.editor.addColumn": "Добавить столбец",
  "notes.editor.deleteRow": "Удалить строку",
  "notes.editor.deleteColumn": "Удалить столбец",
  "notes.editor.deleteTable": "Удалить таблицу",
  "registers.title": "Данные",
  "registers.empty": "Отслеживайте вес, шаги и другое. Значения зашифрованы, прочитать их можете только вы.",
  "registers.pick": "Выберите показатель, чтобы увидеть записи и график.",
  "registers.loading": "Загрузка…",
  "registers.loadFailed": "Не удалось загрузить показатели.",
  "registers.noEntries": "Нет записей",
  "registers.latest": "{value} · {day}",
  "registers.back": "Назад к данным",
  "registers.add": "Добавить запись",
  "registers.addTitle": "Новая запись: {metric}",
  "registers.editTitle": "Изменить запись: {metric}",
  "registers.value": "Значение",
  "registers.valueIn": "Значение, {unit}",
  "registers.when": "Дата и время",
  "registers.comment": "Комментарий",
  "registers.commentHint": "Контекст для вас и ассистента, например «натощак» или «после тренировки».",
  "registers.save": "Сохранить",
  "registers.edit": "Изменить запись",
  "registers.delete": "Удалить запись",
  "registers.deleteTitle": "Удалить эту запись?",
  "registers.deleteText": "Запись удалится на всех ваших устройствах. Это нельзя отменить.",
  "registers.view": "Показать",
  "registers.view.days": "По дням",
  "registers.view.entries": "Все записи",
  "registers.aggregate.avg": "Среднее за день",
  "registers.aggregate.sum": "Сумма за день",
  "registers.dayEntries": "{count, plural, one {# запись} few {# записи} other {# записей}}",
  "registers.sets": "{count, plural, one {# подход} few {# подхода} other {# подходов}}",
  "registers.best": "лучший {value}",
  "registers.bestSet": "Лучший подход",
  "registers.chart": "График: {metric}",
  "registers.more": "Показать более ранние записи",
  "registers.shown": "Показаны последние записи: {count}.",
  "registers.entriesEmpty": "Записей пока нет. Добавьте первую.",
  "registers.entriesLoading": "Загрузка записей…",
  "registers.entriesFailed": "Не удалось загрузить записи.",
  "registers.unreadable": "Нечитаемая запись",
  "registers.invalid.number": "Введите число.",
  "registers.invalid.integer": "Введите целое число.",
  "registers.invalid.precision": "Не больше знаков после запятой: {places}.",
  "registers.invalid.range": "Введите значение от {min} до {max}.",
  "registers.invalid.when": "Укажите дату и время.",
  "registers.conflict": "Запись изменили на другом устройстве; показана её версия.",
  "registers.error.limit": "В аккаунте уже максимальное число записей.",
  "registers.unit.kg": "кг",
  "registers.unit.cm": "см",
  "registers.unit.kcal": "ккал",
  "registers.unit.s": "с",
  "saved.title": "Избранные сообщения",
  "saved.empty": "Здесь появятся сообщения, которые вы сохраните.",
  "saved.loading": "Загружаем избранное…",
  "saved.loadFailed": "Не удалось загрузить избранное.",
  "saved.more": "Показать ещё",
  "saved.open": "Открыть в чате",
  "saved.remove": "Убрать из избранного",
  "saved.error.limit": "Сохранить можно не больше 10 000 сообщений.",
  "permissions.title": "Разрешить агенту прочитать ваши данные?",
  "permissions.intro": "В чате «{chat}» агент просит прочитать:",
  "permissions.introNoChat": "Агент просит прочитать:",
  "permissions.session": "Часовой пояс, страна и язык этого устройства",
  "permissions.history": "Ранние сообщения чата, до {count}",
  "permissions.web": "Сайт",
  "permissions.webTitle": "Разрешить агенту открыть этот сайт?",
  "permissions.webIntro": "В чате «{chat}» агент просит открыть:",
  "permissions.webIntroNoChat": "Агент просит открыть:",
  "permissions.webWarning":
    "Сайт увидит этот адрес и IP сервера. В адресе можно вынести данные, поэтому проверьте, что в нём нет личного. Разрешение действует на этот сайт до конца ответа.",
  "permissions.weather": "Ваше место, для погоды",
  "permissions.weatherTitle": "Использовать это место для погоды?",
  "permissions.weatherIntro": "В чате «{chat}» агент просит погоду там, куда указывает ваш IP:",
  "permissions.weatherIntroNoChat": "Агент просит погоду там, куда указывает ваш IP:",
  "permissions.weatherWarning":
    "Определено по IP, поэтому это может быть другой город, особенно в мобильной сети или через VPN. Модель узнает это место, а сервис погоды получит его округлённые координаты, но не ваш IP. Если город неверный, откажите и назовите свой.",
  "permissions.file": "Файл из чата",
  "permissions.days.all": "Все записи",
  "permissions.days.range": "{from} – {to}",
  "permissions.days.from": "С {from}",
  "permissions.days.to": "По {to}",
  "permissions.reason": "Причина, словами агента",
  "permissions.noReason": "Агент не указал причину.",
  "permissions.unreadableReason": "Причину не удалось расшифровать.",
  "permissions.host":
    "Если разрешить, эти данные уйдут на сервер, а с него — в {host}: он пишет ответ и может сохранить полученное. В чате останется ответ, который может их цитировать, но не сами данные.",
  "permissions.noHost":
    "Провайдера этого чата больше нет в ваших настройках, поэтому непонятно, куда уйдут данные. Отклоните запрос.",
  "permissions.approve": "Разрешить",
  "permissions.addTitle": "Добавить эту запись в ваши данные?",
  "permissions.addIntro": "В чате «{chat}» агент предлагает добавить:",
  "permissions.addIntroNoChat": "Агент предлагает добавить:",
  "permissions.addLabel": "Запись, которую предлагает агент",
  "permissions.addApprove": "Добавить",
  "permissions.addSameDay": "В этот день уже есть записи: {count}. Новая может оказаться дублем.",
  "permissions.addFailedTitle": "Запись не сохранена",
  "permissions.addFailed":
    "Вы подтвердили её, и агенту сообщили о сохранении, но сохранить не удалось. Повторите или добавьте её вручную в разделе данных.",
  "permissions.addRetry": "Повторить",
  "permissions.deny": "Отклонить",
  "permissions.close": "Закрыть и отклонить",
  "permissions.failed": "Ответ не отправлен. Проверьте соединение и попробуйте ещё раз.",
  "permissions.more":
    "{count, plural, one {После этого ждёт ещё # запрос.} few {После этого ждут ещё # запроса.} many {После этого ждут ещё # запросов.} other {После этого ждут ещё # запроса.}}",
  "tools.label": "Данные, которые запросил агент",
  "tools.list_metrics": "Список измерений",
  "tools.read_register": "{metric}, {days}",
  "tools.session_context": "Часовой пояс, страна и язык",
  "tools.read_history": "Ранние сообщения чата",
  "tools.read_history_count": "Ранние сообщения чата: {count}",
  "tools.read_file": "Файл из чата",
  "tools.set_goal": "Предложенная цель: {metric}",
  "permissions.goalTitle": "Поставить эту цель?",
  "permissions.goalIntro": "Агент предлагает такую цель для ваших данных:",
  "permissions.goalLabel": "Цель, которую предлагает агент",
  "permissions.goalApprove": "Поставить",
  "permissions.goalRemove": "Убрать цель",
  "registers.goal.open": "Цель",
  "registers.goal.title": "Цель: {metric}",
  "registers.goal.remove": "Убрать",
  "registers.goal.targetLabel": "Значение, которого хотите достичь",
  "registers.goal.targetIn": "Значение, которого хотите достичь, {unit}",
  "registers.goal.line": "Цель",
  "registers.goal.path": "Ожидаемый путь",
  "registers.goal.target": "Цель: {value}",
  "registers.goal.expected": "ожидается сегодня: {value}",
  "registers.goal.since": "Начало пути",
  "registers.goal.until": "Достичь к (необязательно)",
  "registers.goal.untilInvalid": "Выберите день позже начала",
  "registers.goal.sinceInvalid": "Выберите день",
  "registers.goal.by": "к {day}",
  "registers.goal.from": "от {value} ({day})",
  "registers.goal.fromDay": "с {day}",
  "registers.goal.overdue": "срок прошёл",
  "registers.goal.targetRequired": "Введите значение, которого хотите достичь",
  "tools.add_measurement": "Предложенная запись: {metric}",
  "tools.other": "Инструмент {tool}",
  "tools.web_fetch": "Сайт {host}",
  "tools.get_weather": "Погода",
  "tools.write_memory": "Обновлена память чата",
  "tools.run_code": "Вычисление",
  "tools.outcome.running": "выполняется",
  "tools.outcome.approved": "разрешено",
  "tools.outcome.denied": "отклонено",
  "tools.outcome.refused": "недоступно",
  "tools.outcome.timeout": "нет ответа",
  "tools.outcome.cancelled": "отменено",
  "tools.outcome.waiting": "ждёт вашего ответа",
  "tools.outcome.reading": "читаются",
  "settings.access": "Доступ агента",
  "settings.access.note": "Каждый запрос агента на чтение ваших данных и чем он закончился.",
  "settings.access.locked": "Разблокируйте, чтобы увидеть запросы агента.",
  "settings.access.empty": "Агент ещё не запрашивал данные.",
  "settings.access.failed": "Не удалось загрузить запросы агента.",
  "settings.access.more": "Показать ещё",
  "settings.access.reason": "Причина",
  "settings.access.chat": "Чат «{chat}»",
  "settings.access.outcome.approved": "Разрешено",
  "settings.access.outcome.denied": "Отклонено",
  "settings.access.outcome.refused": "Недоступно на устройстве",
  "settings.access.outcome.timeout": "Нет ответа вовремя",
  "settings.access.outcome.cancelled": "Отменено вместе с ответом",
  "settings.access.outcome.waiting": "Ждёт ответа",
  "settings.access.outcome.answered": "Прочитано без вопроса",

  "settings.back": "Назад к настройкам",
  "settings.general": "Общие",
  "settings.general.hint": "Тема, язык и настройки чатов по умолчанию",
  "settings.providers.hint": "Модели и API-ключи",
  "settings.keys.hint": "Ключи доступа, ключ восстановления и это устройство",
  "settings.account": "Аккаунт",
  "settings.account.hint": "Способы входа, выход и удаление",
  "settings.sessions.hint": "Где выполнен вход в этот аккаунт",
  "settings.activity.hint": "Входы и изменения аккаунта",
  "settings.access.hint": "Что агент просил прочитать",
  "settings.title": "Настройки",
  "settings.appearance": "Оформление",
  "settings.chats": "Чаты",
  "settings.chats.note": "Для чатов, где это не выбрано в настройках чата.",
  "settings.chats.locked": "Разблокируйте, чтобы изменить настройки чатов.",
  "settings.chats.saveFailed": "Не удалось сохранить настройки чатов. Попробуйте ещё раз.",
  "settings.theme": "Тема",
  "settings.theme.system": "Как в системе",
  "settings.theme.light": "Светлая",
  "settings.theme.dark": "Тёмная",
  "settings.theme.amoled": "AMOLED (чёрная)",
  "settings.language": "Язык",

  "signIn.title": "Вход",
  "signIn.intro":
    "Вход открывает ваш аккаунт. Чаты и заметки остаются запертыми, пока вы не разблокируете их ключом доступа или ключом восстановления.",
  "signIn.google": "Войти через Google",
  "signIn.email.title": "Вход по почте",
  "signIn.email.label": "Адрес почты",
  "signIn.email.send": "Отправить код",
  "signIn.code.label": "Код из письма",
  "signIn.code.hint": "Мы отправили 8-значный код на {email}. Он действует 10 минут.",
  "signIn.code.submit": "Войти",
  "signIn.code.other": "Другой адрес",
  "signIn.code.resend": "Отправить новый код",
  "signIn.none": "На этом сервере не настроен ни один способ входа. Обратитесь к администратору.",
  "signIn.loading": "Загрузка…",
  "signIn.error.cancelled": "Вход через Google отменён.",
  "signIn.error.failed": "Вход через Google не завершился. Попробуйте ещё раз.",
  "signIn.error.unavailable": "Google сейчас недоступен. Попробуйте позже.",
  "error.auth.invalid_email": "Введите корректный адрес почты.",
  "error.auth.code_invalid": "Код не подходит. Проверьте его и попробуйте ещё раз.",
  "error.auth.code_expired": "Код истёк или был введён неверно слишком много раз. Запросите новый.",
  "error.auth.signup_closed": "С этим адресом нельзя создать аккаунт на этом сервере.",
  "error.auth.email_unverified":
    "Google не подтвердил этот адрес, а он уже используется аккаунтом. Войдите другим способом и привяжите Google в настройках.",
  "error.auth.reauth_required": "Для безопасности войдите заново перед удалением аккаунта.",
  "error.identity.in_use":
    "Этот способ входа принадлежит другому аккаунту. Аккаунты нельзя объединить: сначала удалите другой аккаунт.",
  "error.identity.last": "Это ваш единственный способ входа.",
  "error.rate_limited": "Слишком много попыток. Подождите минуту и попробуйте снова.",
  "error.network": "Сервер недоступен. Проверьте подключение.",
  "error.generic": "Что-то пошло не так. Попробуйте ещё раз.",
  "settings.identities": "Способы входа",
  "settings.identity.google": "Google",
  "settings.identity.email": "Почта",
  "settings.identity.unverified": "Адрес не подтверждён Google",
  "settings.identity.added": "Добавлен {date}",
  "settings.identity.remove": "Удалить",
  "settings.identity.removeLabel": "Удалить {name}",
  "settings.identity.linkGoogle": "Привязать Google",
  "settings.identity.addEmail": "Добавить адрес почты",
  "settings.identity.linked":
    "{result, select, google {Аккаунт Google привязан.} exists {Этот аккаунт Google уже привязан.} other {Этот аккаунт Google принадлежит другому аккаунту. Аккаунты нельзя объединить: сначала удалите другой аккаунт.}}",
  "settings.identity.emailAdded": "Адрес добавлен.",
  "settings.sessions": "Устройства со входом",
  "settings.session.current": "Это устройство",
  "settings.session.agent": "{browser}, {os}",
  "settings.session.unknownDevice": "Неизвестный браузер",
  "settings.session.signedIn": "{provider, select, google {Вход {date} через Google} other {Вход {date} по почте}}",
  "settings.session.lastSeen": "Последняя активность {date}",
  "settings.session.ip": "IP-адрес {ip}",
  "settings.session.revoke": "Выйти",
  "settings.session.revokeLabel": "Выйти на устройстве {device}",
  "settings.signOut": "Выйти на этом устройстве",
  "settings.activity": "Активность",
  "settings.activity.more": "Показать ещё",
  "settings.activity.empty": "Пока нет активности.",
  "audit.account.created": "Аккаунт создан",
  "audit.auth.signed_in": "{provider, select, google {Вход через Google} other {Вход по почте}}",
  "audit.auth.sign_in_failed": "Неудачная попытка входа",
  "audit.auth.code_sent": "Отправлен код для входа",
  "audit.session.revoked":
    "{reason, select, sign_out {Выход} device_replaced {Выход: новый вход на том же устройстве} refresh_reused {Выход: обнаружено повторное использование старого входа} idle {Выход после долгого бездействия} identity_unlinked {Выход: способ входа удалён} other {Выход с другого устройства}}",
  "audit.identity.linked": "{provider, select, google {Привязан аккаунт Google} other {Привязан адрес почты}}",
  "audit.identity.unlinked": "{provider, select, google {Аккаунт Google отвязан} other {Адрес почты отвязан}}",
  "audit.keys.setup": "Ключи настроены",
  "audit.keys.wrap_added":
    "{method, select, passkey {Добавлен ключ доступа} device {Устройство запомнено} other {Добавлен способ разблокировки}}",
  "audit.keys.wrap_removed":
    "{method, select, passkey {Удалён ключ доступа} device {Устройство забыто} other {Удалён способ разблокировки}}",
  "audit.keys.recovery_rotated": "Ключ восстановления заменён",
  "audit.link.completed": "Устройство разблокировано через привязку",
  "audit.chat.created": "Создан чат",
  "audit.chat.archived": "Чат перенесён в архив",
  "audit.chat.unarchived": "Чат возвращён из архива",
  "audit.chat.deleted": "Чат удалён",
  "audit.unknown": "Другое действие",
  "settings.delete": "Удаление аккаунта",
  "settings.delete.intro":
    "Удаляет аккаунт и всё, что в нём есть, с этого сервера: чаты, заметки, данные, ключи и историю. Отменить это нельзя.",
  "settings.delete.button": "Удалить аккаунт…",
  "settings.delete.dialogTitle": "Удалить аккаунт?",
  "settings.delete.confirmLabel": "Введите {phrase} для подтверждения",
  "settings.delete.phrase": "удалить",
  "settings.delete.confirm": "Удалить навсегда",
  "settings.delete.reauth": "Войти заново",

  "keys.loading.title": "Разблокировка",
  "keys.loading.text": "Загружаем ваши ключи…",
  "keys.loading.failed": "Не удалось загрузить ключи. Проверьте соединение и попробуйте снова.",
  "keys.setup.title": "Настройка ключей",
  "keys.setup.intro":
    "Ваши чаты, заметки и данные хранятся зашифрованными ключами, которые есть только на ваших устройствах. Сервер хранит их запертыми и открыть не может.",
  "keys.setup.loss":
    "Разблокировка — ключом доступа (passkey) или ключом восстановления. Если потерять их все, данные пропадут навсегда: восстановить их не сможет никто, даже администратор сервера.",
  "keys.setup.server":
    "Пока вы пользуетесь чатом, сервер и ваш провайдер ИИ видят его сообщения. Шифрование защищает то, что хранится, а не идущий разговор.",
  "keys.setup.knownWarning":
    "Сервер сообщает, что у аккаунта нет ключей, хотя этот браузер уже разблокировал его раньше. Если вы не удаляли аккаунт, сервер может работать неправильно. Новые ключи не вернут то, что хранилось под старыми.",
  "keys.setup.start": "Настроить",
  "keys.setup.step": "Шаг {n} из {total}",
  "keys.setup.passkey":
    "Ключ доступа разблокирует отпечатком пальца, лицом или PIN-кодом устройства. Ключи, синхронизированные менеджером паролей, разблокируют и другие ваши устройства.",
  "keys.setup.passkeyUnavailable":
    "Этот браузер не может хранить ваш ключ в ключе доступа. Разблокировать придётся ключом восстановления; ключ доступа можно добавить позже на устройстве, которое это поддерживает.",
  "keys.setup.skipPasskey": "Пропустить, только ключ восстановления",
  "keys.setup.continue": "Продолжить",
  "keys.setup.passkeyAdded": "Ключ доступа добавлен.",
  "keys.setup.finish": "Завершить настройку",
  "keys.passkey.name": "Vault Chat",
  "keys.passkey.create": "Создать ключ доступа",
  "keys.passkey.add": "Добавить ключ доступа",
  "keys.recovery.intro":
    "Это ваш ключ восстановления. Запишите слова по порядку и храните в надёжном месте не в сети. Любой, у кого есть эти слова, может разблокировать ваши данные.",
  "keys.recovery.label": "Ключ восстановления",
  "keys.recovery.once": "Слова показываются только один раз.",
  "keys.recovery.written": "Слова записаны",
  "keys.recovery.suggestions": "Подходящие слова",
  "keys.confirm.intro": "Чтобы убедиться, что копия верна, введите из неё эти слова.",
  "keys.confirm.word": "Слово {n}",
  "keys.confirm.wrongWord": "Слово не совпадает.",
  "keys.confirm.mismatch": "Некоторые слова не совпадают. Проверьте копию или вернитесь к словам.",
  "keys.confirm.back": "Показать слова ещё раз",
  "keys.remember.label": "Запомнить это устройство",
  "keys.remember.hint":
    "Разблокирует в этом браузере без ключа доступа и ключа восстановления, пока вы не выйдете здесь. Любой, у кого окажется это устройство с активным входом, сможет читать ваши данные. Не включайте на общем устройстве.",
  "keys.unlock.title": "Разблокировка",
  "keys.unlock.intro":
    "Вы вошли. Чаты, заметки и данные остаются запертыми, пока вы не разблокируете их в этой вкладке.",
  "keys.unlock.passkey": "Разблокировать ключом доступа",
  "keys.unlock.recoveryTitle": "Ключ восстановления",
  "keys.unlock.recoveryHint": "12 слов по порядку через пробел.",
  "keys.unlock.recovery": "Разблокировать",
  "keys.link.title": "С помощью телефона",
  "keys.link.intro":
    "Если на телефоне выполнен вход и данные разблокированы, он может разблокировать это устройство: отсканируйте код его камерой.",
  "keys.link.show": "Показать код",
  "keys.link.qr": "Код для сканирования телефоном",
  "keys.link.scan": "Откройте камеру телефона и наведите её на код. Код меняется каждые 2 минуты.",
  "keys.link.hide": "Скрыть код",
  "keys.link.failed": "Ответ телефона не подошёл к этому коду. Покажите новый код и отсканируйте его снова.",
  "keys.linkPage.title": "Разблокировать другое устройство",
  "keys.linkPage.ask":
    "Устройство, на котором выполнен вход в ваш аккаунт, просит разблокировать его. Ниже — то, что оно сообщает о себе; тот, кто им управляет, может указать что угодно.",
  "keys.linkPage.device": "{browser}, {os}",
  "keys.linkPage.unknownDevice": "Неизвестный браузер",
  "keys.linkPage.created": "Код показан {date}",
  "keys.linkPage.warning":
    "Продолжайте, только если вы сами только что отсканировали этот код со своего экрана. Никогда — для кода или ссылки, которые вам прислали. Разблокированное устройство получит доступ ко всему в аккаунте.",
  "keys.linkPage.confirm": "Разблокировать устройство",
  "keys.linkPage.cancel": "Отмена",
  "keys.linkPage.done": "Другое устройство разблокировано. Эту страницу можно закрыть.",
  "keys.linkPage.cancelled": "Ничего не отправлено.",
  "keys.linkPage.expired":
    "Этот код уже недействителен. Покажите новый код на другом устройстве и отсканируйте его снова.",
  "keys.linkPage.used": "Этот код уже использован.",
  "keys.linkPage.home": "К чатам",
  "keys.linkPage.signedOutTitle": "Сначала войдите на этом телефоне",
  "keys.linkPage.signedOut":
    "Чтобы разблокировать другое устройство, на этом телефоне нужно войти в аккаунт и разблокировать данные. Войдите и отсканируйте код на другом устройстве ещё раз.",
  "keys.linkPage.signIn": "Войти",
  "keys.error.wrong": "Это не разблокирует ваш аккаунт. Проверьте слова или попробуйте другой способ.",
  "keys.error.length": "В ключе восстановления 12 слов.",
  "keys.error.word": "Слова {n} нет в списке слов ключа восстановления. Проверьте написание.",
  "keys.error.checksum": "Эти слова не являются ключом восстановления. Проверьте порядок и написание.",
  "keys.error.exists": "Ключи только что настроены на другом устройстве. Разблокируйте ими.",
  "keys.error.limit": "У аккаунта уже максимум ключей доступа. Сначала удалите один.",
  "keys.error.device": "Не удалось запомнить устройство. Выйдите, войдите снова и повторите.",
  "keys.error.passkeyCancelled": "Окно ключа доступа закрыто. Попробуйте снова, когда будете готовы.",
  "keys.error.noPrf":
    "Этот ключ доступа не может хранить ключ. Используйте ключ восстановления или ключ доступа из менеджера паролей или устройства, которое это поддерживает.",
  "keys.error.passkeyFailed": "Ключ доступа не сработал в этом браузере.",
  "providers.title": "ИИ-провайдеры",
  "providers.locked": "Разблокируйте, чтобы управлять ИИ-провайдерами.",
  "providers.loadFailed":
    "Не удалось прочитать настройки провайдеров. Перезагрузите страницу, чтобы попробовать снова.",
  "providers.saveFailed": "Не удалось сохранить изменение. Попробуйте ещё раз.",
  "providers.intro":
    "Чаты используют провайдера, которого вы выберете здесь. Его настройки, включая API-ключ, хранятся зашифрованными вместе с остальными вашими данными. Пока приложение открыто и разблокировано, и ещё две минуты после, сервер держит их в памяти, чтобы обращаться к провайдеру; ответ, который ещё пишется, держит их до своего конца, не дольше 10 минут. Провайдер видит то, что вы ему отправляете.",
  "providers.empty": "Провайдеров пока нет. Добавьте, чтобы начать общение.",
  "providers.noneActive": "Выберите, какого провайдера используют чаты.",
  "providers.agent.refused":
    "Сервер отказался работать с этим провайдером. Проверьте адрес и модель; адрес в частной сети работает, только если это разрешил администратор сервера.",
  "providers.agent.failed":
    "Не удалось запустить ассистента с этим провайдером. Он попробует снова, когда соединение восстановится.",
  "providers.list": "Провайдеры",
  "providers.active": "Используется",
  "providers.kind.openai_compatible": "API, совместимый с OpenAI",
  "providers.kind.anthropic": "API Anthropic",
  "providers.use": "Использовать",
  "providers.useLabel": "Использовать {name}",
  "providers.edit": "Изменить",
  "providers.editLabel": "Изменить {name}",
  "providers.remove": "Удалить",
  "providers.removeLabel": "Удалить {name}",
  "providers.removeTitle": "Удалить {name}?",
  "providers.removeIntro":
    "Он будет удалён из ваших настроек вместе с API-ключом, и сервер перестанет его использовать. Ответы, которые ещё пишутся, тоже остановятся, если только связь не оборвётся в этот момент: тогда они могут идти ещё до 10 минут. Сообщения в чатах останутся. Сам ключ при этом продолжит работать: его видели сервер и провайдер, поэтому, если он мог утечь или больше не нужен, отзовите его и в аккаунте у провайдера.",
  "providers.share": "Поделиться",
  "providers.shareLabel": "Поделиться {name}",
  "providers.share.title": "Поделиться {name}",
  "providers.share.intro":
    "Передайте этого провайдера другому человеку или устройству на другом сервере QR-кодом или ссылкой. На ваших устройствах он уже есть.",
  "providers.share.warningKey":
    "Код и ссылка содержат API-ключ в открытом виде. Любой, кто увидит код, сфотографирует его или получит ссылку, сможет пользоваться ключом и тратить деньги с вашего счёта у провайдера. Телефон, который его сканирует, может сохранить ссылку в истории браузера, а скопированная ссылка остаётся в буфере обмена.",
  "providers.share.warningNoKey":
    "Код и ссылка содержат адрес провайдера и модель, без API-ключа. Тот, кто добавит провайдера, введёт свой ключ.",
  "providers.share.withKey": "Включить API-ключ",
  "providers.share.withKeyHint": "Уберите, если у другого человека есть свой ключ.",
  "providers.share.show": "Показать QR-код",
  "providers.share.qr": "Код с настройками провайдера",
  "providers.share.scan": "Отсканируйте его камерой другого телефона и откройте ссылку.",
  "providers.share.copy": "Скопировать ссылку",
  "providers.share.copied": "Ссылка скопирована.",
  "providers.share.copyFailed": "Не удалось скопировать ссылку.",
  "providers.form.link": "Ссылка на провайдера",
  "providers.form.linkHint": "Вставьте ссылку на провайдера, которую вам дали, с любого сервера, чтобы заполнить поля.",
  "providers.form.linkFilled": "Поля заполнены из ссылки. Проверьте их перед сохранением.",
  "providers.form.linkInvalid": "Это не ссылка на провайдера, или она повреждена.",
  "providers.import.title": "Добавить провайдера по ссылке",
  "providers.import.warning":
    "Все чаты с этим провайдером отправляют сообщения на {host}. Добавляйте его, только если знаете, кто дал ссылку, и доверяете этому адресу.",
  "providers.import.withKey": "С API-ключом",
  "providers.import.noKey": "Без API-ключа: добавьте свой в настройках",
  "providers.import.add": "Добавить провайдера",
  "providers.import.added": "{name} добавлен. Выберите его в настройках, чтобы использовать в чатах.",
  "providers.import.addedActive": "{name} добавлен, чаты используют его.",
  "providers.import.known": "Этот провайдер у вас уже есть: {name}.",
  "providers.import.cancelled": "Ничего не добавлено.",
  "providers.import.invalid": "Ссылка повреждена или создана более новой версией приложения.",
  "providers.import.missing": "Нечего добавлять. Откройте ссылку ещё раз.",
  "providers.import.settings": "Перейти в настройки",
  "providers.import.signedOutTitle": "Сначала войдите",
  "providers.import.signedOut":
    "Войдите на этом устройстве, затем снова откройте ссылку или отсканируйте код. Пока вы входите, она не сохраняется, потому что может содержать API-ключ.",
  "providers.add": "Добавить провайдера",
  "providers.form.addTitle": "Новый провайдер",
  "providers.form.editTitle": "Изменить провайдера",
  "providers.form.preset": "Шаблон",
  "providers.form.presetOther": "Другой",
  "providers.form.name": "Название",
  "providers.form.kind": "API",
  "providers.form.baseUrl": "Базовый URL",
  "providers.form.baseUrlHint": "К этому адресу подключается сервер, а не ваше устройство.",
  "providers.form.badUrl": "Введите адрес, который начинается с https:// или http://.",
  "providers.form.apiKey": "API-ключ",
  "providers.form.apiKeyHint": "Оставьте пустым, если провайдеру он не нужен, как Ollama.",
  "providers.form.apiKeyEditHint":
    "Заменённый здесь ключ продолжит работать у провайдера: отзовите старый там. Оставьте пустым, если провайдеру ключ не нужен.",
  "providers.form.model": "Модель",
  "providers.form.modelHint": "Название модели в точности как у провайдера.",
  "providers.form.required": "Обязательное поле.",

  "keys.settings.title": "Разблокировка",
  "keys.settings.locked": "Разблокируйте, чтобы управлять ключами доступа и ключом восстановления.",
  "keys.settings.methods": "Способы разблокировки",
  "keys.method.passkey": "Ключ доступа",
  "keys.method.recovery": "Ключ восстановления",
  "keys.method.device": "Это устройство",
  "keys.method.added": "Добавлен {date}",
  "keys.method.remove": "Удалить",
  "keys.method.removeLabel": "Удалить ключ доступа, добавленный {date}",
  "keys.rotate.button": "Заменить…",
  "keys.rotate.title": "Замена ключа восстановления",
  "keys.rotate.intro":
    "Вы получите новые слова. Как только вы их подтвердите, старые перестанут работать. Ключи доступа и запомненные устройства продолжат работать.",
  "keys.rotate.start": "Показать новые слова",
  "keys.rotate.finish": "Заменить ключ восстановления",
  "keys.rotate.done": "Ключ восстановления заменён. Старые слова больше не работают.",

  "connection.connecting": "Подключение…",
  "connection.waiting":
    "Соединение потеряно. Повтор через {seconds, plural, one {# секунду} few {# секунды} many {# секунд} other {# секунды}}…",
  "connection.revoked": "Этот сеанс завершён на другом устройстве.",
  "connection.outdated": "Доступна новая версия. Обновите страницу.",

  "common.cancel": "Отмена",
  "common.close": "Закрыть",
  "common.save": "Сохранить",
  "common.delete": "Удалить",
  "common.retry": "Повторить",

  "uiKit.notes": "Заметки",
  "uiKit.files": "Файлы",
  "uiKit.sample.photo": "пляж.jpg",
  "uiKit.sample.report": "отчёт.pdf",
  "uiKit.sample.table": "шаги.csv",
  "uiKit.sample.photoSize": "1,2 МБ",
  "uiKit.sample.reportSize": "340 кБ",
  "uiKit.sample.photoAbout": "Песчаный пляж на закате, у воды идут два человека.",
  "uiKit.chats": "Чаты",
  "uiKit.sample.chatTitle": "Поездка на море",
  "uiKit.sample.chatTitle2": "Итоги недели",
  "uiKit.sample.question": "Какие пляжи тихие в сентябре?\nМы едем с собакой.",
  "uiKit.sample.answer": "Вот три, куда пускают с собаками и где спокойно после сезона.",
  "uiKit.sample.rich.heading": "Три тихих пляжа",
  "uiKit.sample.rich.bold": "С собаками можно",
  "uiKit.sample.rich.italic": "не в сезон",
  "uiKit.sample.rich.struck": "людно",
  "uiKit.sample.rich.link": "путеводитель по побережью",
  "uiKit.sample.rich.beach1": "Золотая бухта",
  "uiKit.sample.rich.beach2": "Сосновый залив",
  "uiKit.sample.rich.task1": "Забронировать номер",
  "uiKit.sample.rich.task2": "Взять миску для собаки",
  "uiKit.sample.rich.quote": "Утром тихо, после четырёх ветрено.",
  "uiKit.sample.rich.callout": "Перед выходом сверьтесь с таблицей приливов.",
  "uiKit.sample.rich.panel": "Как выбраны эти пляжи",
  "uiKit.sample.rich.beach": "Пляж",
  "uiKit.sample.rich.distance": "Расстояние, км",
  "uiKit.sample.rich.dogs": "Собаки",
  "uiKit.sample.rich.water": "Температура воды, °C",
  "uiKit.sample.rich.month": "Месяц",
  "uiKit.sample.rich.trips": "Поездки по пляжам",
  "uiKit.sample.rich.other": "Другие",
  "uiKit.sample.reason": "Чтобы увидеть, как менялся ваш вес в этом месяце.",
  "uiKit.sample.toolRead": "Вес, 1 мар. 2026 г. – 31 мар. 2026 г.",
  "uiKit.sample.time": "вчера",
  "uiKit.sample.toast": "Показать уведомление",
  "uiKit.title": "UI kit",
  "uiKit.intro": "Все компоненты и варианты — для проверки в каждой теме и на каждом языке.",
  "uiKit.buttons": "Кнопки",
  "uiKit.fields": "Поля",
  "uiKit.feedback": "Сообщения",
  "uiKit.list": "Список",
  "uiKit.sample.listTitle": "Firefox, Linux",
  "uiKit.sample.listDetail": "Последняя активность вчера",
  "uiKit.sample.listDetail2": "IP-адрес 203.0.113.7",
  "uiKit.typography": "Типографика",
  "uiKit.dialog": "Диалог",
  "uiKit.sample.primary": "Основная",
  "uiKit.sample.secondary": "Вторичная",
  "uiKit.sample.danger": "Опасная",
  "uiKit.sample.ghost": "Без фона",
  "uiKit.sample.disabled": "Недоступна",
  "uiKit.sample.field": "Имя",
  "uiKit.sample.fieldHint": "Видно только вам.",
  "uiKit.sample.checkbox": "Запомнить выбор",
  "uiKit.sample.fieldError": "Введите имя.",
  "uiKit.sample.info": "Ваши данные зашифрованы ключами, которые есть только на ваших устройствах.",
  "uiKit.sample.success": "Сохранено.",
  "uiKit.sample.warning": "Запишите ключ восстановления. Он показывается только один раз.",
  "uiKit.sample.danger.text": "Потеря всех ключей означает потерю данных.",
  "uiKit.crypto": "Крипто-воркер",
  "uiKit.crypto.run": "Запустить самопроверку",
  "uiKit.crypto.ok": "Самопроверка пройдена: ключи созданы, запись зашифрована и расшифрована в воркере.",
  "uiKit.crypto.failed": "Самопроверка не прошла: {error}",
  "uiKit.sample.openDialog": "Открыть диалог",
  "uiKit.sample.dialogTitle": "Разрешить доступ?",
  "uiKit.sample.dialogBody": "Ассистент просит прочитать ваши шаги за последние 7 дней.",
  "uiKit.sample.heading": "Съешь же ещё этих мягких французских булок",
  "uiKit.sample.body": "Основной текст задаёт ритм чтения. Он переносится по удобной длине строки.",
};
